import classNames from "classnames";
import React from "react";

interface Props {
  uri?: string;
  icon: React.ReactNode;
  title: React.ReactNode;
  iconTitleGap?: "gap" | "gap-small"
}

export const LargeClickableTitle = (props: Props) => {
  const className = classNames("flex align-center", props.iconTitleGap ?? "gap-small")
  return <a href={props.uri}>
    <div className={className}>
      {props.icon}
      <div>
        {props.title}
      </div>
    </div>
  </a>
}